module.exports = __webpack_public_path__ + "static/ombre-logo-ca6f26b95584a857a4e71116287e99a8.svg";